module.exports = __webpack_public_path__ + "static/img/h30.e424671.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rural/tour1/h30.jpg
// module id = U68g
// module chunks = 0